import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'css-invoice-remit-info',
  templateUrl: './css.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './css.scss',
})
export class CssInvoiceRemitComponent{}
